








import { Component, Vue } from 'vue-property-decorator'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { LocaleProvider } from 'ant-design-vue'
import { getCurrentLocale } from '@/i18n'
import { detect } from 'detect-browser'

const localeMap: any = {
  en: enUS,
  zh: zhCN
}

@Component({
  components: {
    LocaleProvider
  }
})
export default class App extends Vue {
  get locale() {
    const locale = this.$store.getters.currentLocale
    const result = localeMap[locale]
    return result
  }

  get i18n() {
    const value = this.$t('app')
    return value as any
  }

  mounted() {
    const { name } = detect() || { name: 'chrome' }
    const tip = name == 'ie'
      ? this.i18n.notSupportBrowserTip
      : !['chrome', 'safari', 'opera', 'edge', 'firefox'].includes(name)
      ? this.i18n.betterBrowserTip
      : ''
    if (tip) {
      const el = document.createElement('div')
      el.innerHTML = `<div class="topbar-browser-tip" id="topbar-browser-tip">${tip}</div>`
      document.body.appendChild(el)
      document.body.style.paddingTop = '38px'
    }
    document.title = this.i18n.htmltitle
  }
}
